import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOutdoorBarArticleCategories } from '../../api/fetch-outdoor-bar-article-categories';

export const fetchOutdoorBarArticleCategoriesThunk = createAsyncThunk(
    'fetchOutdoorBarArticleCategories',
    async () => fetchOutdoorBarArticleCategories(),
);
